import React from 'react';
import { Box, Tooltip } from '@mui/material';

const FoundCount = ({ count }) => (count ? (
    <Tooltip title={`Found flows: ${count}`}>
        <Box
            component="span"
            sx={{
                minWidth: '20px',
                height: '20px',
                paddingX: '6px',
                borderRadius: '10px',
                backgroundColor: '#FFD54F',
                color: '#3B465C',
                fontSize: '12px',
                fontWeight: 600,
                lineHeight: '20px',
                textAlign: 'center',
                flexShrink: 0,
            }}
        >
            {count}
        </Box>
    </Tooltip>
) : null);

export default FoundCount;
